/**
 * Localhost-only Payments UAT (sandbox01) override.
 *
 * Enabled when:
 * - running on localhost, and
 * - REACT_APP_PAYMENTS_UAT_LOCAL=true in .env.local, and
 * - payments-local.json exists at repo root (used by src/setupProxy.js for Basic auth)
 *
 * Browser calls go to /payments-uat/* (CRA proxy → sandbox01).
 * Keys never ship in the JS bundle — only the Node proxy reads payments-local.json.
 */

export function isPaymentsUatLocalEnabled() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  const isLocal =
    host === "localhost" || host === "127.0.0.1" || host === "[::1]";
  if (!isLocal) return false;
  return (
    process.env.REACT_APP_PAYMENTS_UAT_LOCAL === "true" ||
    process.env.REACT_APP_PAYMENTS_UAT_LOCAL === "1"
  );
}

/** Path prefix for CRA setupProxy → sandbox01-api.goodleap.com */
export function paymentsUatLocalPath(apiPath) {
  const normalized = apiPath.startsWith("/") ? apiPath : `/${apiPath}`;
  return `/payments-uat${normalized}`;
}
